/* Klaviyo Reviews — label tidy-up
   Klaviyo renders tag answers with their separator inside the label
   ("Running," / "Gym workouts ·"), which lands inside the chip box.
   CSS cannot trim text, so strip it here.
   Loaded from layout/theme.liquid after the stylesheet. */

(function () {
  var SELECTORS = [
    '#klaviyo-product-reviews-wrapper .kl_reviews__clickable_answer',
    '#klaviyo-product-reviews-wrapper .kl_reviews__custom_question__answer--text',
    '#klaviyo-all-reviews-wrapper .kl_reviews__clickable_answer',
    '#klaviyo-all-reviews-wrapper .kl_reviews__custom_question__answer--text'
  ].join(',');

  /* Trailing comma, middot, bullet, semicolon or slash, plus any
     surrounding whitespace. Leaves counts like "Running (4)" intact. */
  var TRAILING = /[\s]*[,;·•\/]+[\s]*$/;

  /* Which per-review range question to keep visible. The CSS hides
     all of them; this reveals the matching one. Matched against the
     question label, so it works in every storefront language as long
     as one of these words appears. */
  var KEEP_RANGE = /recommend|rekommend|empfehl/i;

  /* Remove the unwanted range questions from the DOM instead of
     hiding them with CSS. Hiding meant CSS had to guess which
     elements belong to which question; here we can read the label
     text and delete exactly that question's nodes. Everything that
     stays keeps Klaviyo's own styling. */
  function dropRangeQuestions() {
    var reviews = document.querySelectorAll(
      '#klaviyo-product-reviews-wrapper .kl_reviews__review_item,' +
      '#klaviyo-all-reviews-wrapper .kl_reviews__review_item'
    );

    reviews.forEach(function (review) {
      var labels = [].slice.call(
        review.querySelectorAll('.kl_reviews__custom_question__question--range')
      );

      labels.forEach(function (label) {
        if (KEEP_RANGE.test(label.textContent || '')) return;
        /* Collect this question's own nodes: the label, then every
           following sibling up to the next range label. */
        var doomed = [label];
        var node = label.nextElementSibling;
        while (node && !node.classList.contains('kl_reviews__custom_question__question--range')) {
          doomed.push(node);
          node = node.nextElementSibling;
        }
        var parent = label.parentElement;
        doomed.forEach(function (n) { n.remove(); });
        /* If that emptied the wrapper, drop it too. */
        if (parent && !parent.textContent.trim() && !parent.querySelector('svg')) parent.remove();
      });

      /* Orphaned label rows: a "Runs small / True to size / Runs
         large" row whose question label lived in another wrapper. */
      review.querySelectorAll('.kl_reviews__custom_question__answer--range').forEach(function (row) {
        var q = row.parentElement
          && row.parentElement.querySelector('.kl_reviews__custom_question__question--range');
        if (q) return;
        var prev = row.previousElementSibling;
        var hasSlider = prev && prev.querySelector && prev.querySelector('svg');
        if (!hasSlider) row.remove();
      });
    });
  }

  function tidy() {
    dropRangeQuestions();
    document.querySelectorAll(SELECTORS).forEach(function (el) {
      /* Only touch the last text node so nested markup survives. */
      var nodes = [].slice.call(el.childNodes).filter(function (n) {
        return n.nodeType === 3 && n.textContent.trim();
      });
      var last = nodes[nodes.length - 1];
      if (!last) return;
      var cleaned = last.textContent.replace(TRAILING, '');
      if (cleaned !== last.textContent) last.textContent = cleaned;
    });
  }

  function watch() {
    var root = document.querySelector('#klaviyo-product-reviews-wrapper')
      || document.querySelector('#klaviyo-all-reviews-wrapper');
    if (!root) return false;
    tidy();
    new MutationObserver(function () {
      /* Debounced: Klaviyo re-renders the list on filter and paging. */
      window.clearTimeout(watch._t);
      watch._t = window.setTimeout(tidy, 30);
    }).observe(root, { childList: true, subtree: true });
    return true;
  }

  /* The widget mounts asynchronously, so poll briefly for it. */
  if (!watch()) {
    var tries = 0;
    var poll = window.setInterval(function () {
      if (watch() || ++tries > 60) window.clearInterval(poll);
    }, 250);
  }
})();
